module.exports = __webpack_public_path__ + "static/desktop-hero-14fca014a6858c27ea3f1e2f4331120d.png";